import type * as React from 'react';
import { sanitize } from '../../../common/services/sanitizer/service';
import { SETTINGS_COMPANY } from '../../../routes';
import { useAppContext } from '../../hooks/useAppContext';
import { prependAppPath } from '../../services/Url';

const CompanyMessage: React.FC = () => {
    const { user } = useAppContext();
    const {
        company: { companySettings },
    } = user;

    if (!companySettings.headerMessage) {
        return null;
    }

    return (
        <div className="broadcast" id="globalMsg">
            <img src="/images/illustrations/bullhorn_icon.svg" alt="" />
            <span dangerouslySetInnerHTML={{ __html: sanitize(companySettings.headerMessage) }} />
            {user.isHR && (
                <a href={prependAppPath(SETTINGS_COMPANY)} className="editLink">
                    Edit
                </a>
            )}
        </div>
    );
};

export default CompanyMessage;
